import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const elements = document.querySelectorAll('#wembii-lith-form');

for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    ReactDOM.render((
        <App
            id={element.getAttribute('id')}
            formId={element.getAttribute('form-id')}
            companyId={element.getAttribute('company-id')}
        />
    ), elements[i]);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
